import { render } from "./ConfirmActionModal.vue?vue&type=template&id=57a9008a&scoped=true"
import script from "./ConfirmActionModal.vue?vue&type=script&lang=js"
export * from "./ConfirmActionModal.vue?vue&type=script&lang=js"

import "./ConfirmActionModal.vue?vue&type=style&index=0&id=57a9008a&scoped=true&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57a9008a"]])

export default __exports__